<script lang="ts">
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    import { faAngleRight, faSave } from '@fortawesome/free-solid-svg-icons'
    import Zinput from '../../_common/z/zinput.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import { CompaniesRepository } from '../../../modules/usersApi/companies/companies.repository'
    import { CompaniesService } from '../../../modules/usersApi/companies/companies.service'
    import { Company } from '../../../modules/usersApi/companies/company'
    import type { CompanyCreateDto } from '../../../modules/usersApi/companies/dto/company-create.dto'
    // ##############################################################################################################

    let step = 1
    const rep = new CompaniesRepository()
    const service = new CompaniesService(rep)
    const timezones = service.getTimezones()

    let show = false
    export let company: Company = new Company()

    async function createEntity() {
        // criar empresa não pode acontecer duas vezes: qualquer caminho que dispare a ação de novo
        // enquanto a primeira está no ar (duplo toque, Enter junto do clique) para aqui
        if (show) return
        try {
            show = true
            const dto: CompanyCreateDto = {
                companyName: company.companyName,
                email: company.email,
                timezone: company.timezone,
            }
            if (!dto.companyName || !dto.email || !dto.timezone) {
                window.error('Todos os campos devem ser preenchidos')
                return
            }
            if (!dto.email.includes('@')) {
                window.error('Informe um e-mail válido')
                return
            }
            company = await service.create(dto)
            sendClose()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function sendClose() {
        dispatch('close', company)
    }

    function getUser() {
        let contact = window.store.user.phone
        if (contact) contact = window.api.utils.utils.phoneFriendly(contact)
        if (!contact) contact = window.store.user.email
        let user = (window.store.user?.userName || '') + ' (' + contact + ')'
        return user
    }

    async function goLogout() {
        await window.api.users.auth.logout(false)
        location.href = '/login'
    }
</script>

{#if company}
    <div class="root">
        {#if step === 1}
            <h1>Bem-vindo ao Zandu</h1>
            <p class="sub">
                O usuário <b>{getUser()}</b> ainda não tem uma empresa no Zandu. Crie a sua para começar a usar a agenda, o caixa e os clientes.
            </p>
            <Zbutton color="primary" icon={faAngleRight} label="Criar uma empresa" grow={true} growM={true} on:click={() => (step = 2)} />
            <div class="links">
                <button class="link" on:click={goLogout}>Quero entrar com outro usuário</button>
            </div>
        {/if}
        {#if step === 2}
            <h1>Sua empresa</h1>
            <p class="sub">O fuso horário define os horários da agenda e dos relatórios. Dá para mudar tudo isso depois.</p>
            <!-- o submit nativo é o que faz o Enter salvar; o botão visível é o Zbutton -->
            <form on:submit|preventDefault={createEntity}>
                <ZContainer gapRow="8px" gapCol="8px">
                    <Zinput size={12} label="Nome da empresa" type="text" autocomplete="organization" bind:value={company.companyName} />
                    <Zinput size={5} sizeM={12} label="E-mail da empresa" type="text" autocomplete="email" bind:value={company.email} />
                    <Zinput size={7} sizeM={12} label="Fuso horário" type="select" options={timezones} bind:value={company.timezone} />
                </ZContainer>
                <button type="submit" class="submit-native" tabindex="-1" aria-hidden="true"></button>
                <Zbutton color="primary" icon={faSave} label="Salvar" grow={true} growM={true} loading={show} disabled={show} on:click={createEntity} />
            </form>
            <div class="links">
                <button class="link" on:click={() => (step = 1)}>Voltar</button>
            </div>
        {/if}
    </div>
{/if}

<style>
    /* Mesma situação da tela de login: este formulário fica sobre a ilustração colorida e é sempre
       escuro, com tema claro ou escuro. Os campos do app são translúcidos de propósito (pegam o que
       está atrás) — aqui isso os deixaria avermelhados —, então as variáveis de campo voltam a
       valores opacos neste bloco. Como variável CSS herda, vale para todo Zinput desenhado aqui,
       inclusive a lista do select (solid-bg) e a folha de tela inteira do celular (sheet-bg). */
    .root {
        --z-field-bg: #2b2b2b;
        --z-field-border: #ffffff26;
        --z-field-text: #eeeeee;
        --z-field-label: #a8a8a8;
        --z-field-solid-bg: #2b2b2b;
        --z-field-sheet-bg: #161616;
        --z-field-act-bg: #ffffff12;
        --z-field-act-bg-hover: #ffffff1f;

        max-width: 560px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        color: #f2f2f2;
        padding: 0px 8px 8px 8px;
    }

    h1 {
        font-size: 26px;
        font-weight: 600;
        margin: 0px;
    }
    .sub {
        margin: 6px 0px 20px;
        font-size: 14px;
        line-height: 1.35;
        color: #c7c7c7;
    }
    .sub b {
        color: #f2f2f2;
        font-weight: 600;
    }

    form {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    /* existe só para o Enter enviar o formulário — o botão visível é o Zbutton */
    .submit-native {
        display: none;
    }

    .links {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-top: 16px;
    }
    .link {
        border: 0px;
        background: none;
        padding: 0px;
        color: #cfe8dc;
        font-size: 14px;
        text-decoration: underline;
        cursor: pointer;
    }
    .link:hover {
        color: #ffffff;
    }
</style>
